/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserInfo = {
  properties: {
    username: {
      type: 'string',
      isRequired: true,
    },
    user_type: {
      type: 'string',
      isRequired: true,
    },
    cci_code: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
